export const cookieConsentId = 'cookie-consent';
